<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    :aria-busy="loading ? 'true' : 'false'"
  >
    <!-- Accessible loader -->
    <template v-slot:loader>
      <v-progress-circular
        indeterminate
        size="20"
        width="2"
        :aria-label="computedLoadingLabel"
      />
    </template>

    <!-- Button content -->
    <span v-if="loading && showLoadingText">
      {{ computedLoadingLabel }}
    </span>
    <slot v-else />
  </v-btn>
</template>

<script>
export default {
  name: "LoadingButton",
  props: {
    loading: Boolean,

    // Accessible + optional visible text
    loadingLabel: {
      type: String,
      default: "Loading"
    },

    // Toggle visible replacement text
    showLoadingText: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    computedLoadingLabel() {
      return this.loadingLabel;
    }
  }
};
</script>
